import { Checkbox } from "@mui/material";

const ActionCheckBox = ({ handleCheckboxChange, checkedItems, item }) => {
  return (
    <Checkbox
      sx={{ p: 0 }}
      onChange={(e) => {
        handleCheckboxChange(e, item);
      }}
      checked={checkedItems?.some((checked) => checked.idtest_step === item.idtest_step)}
    />
  );
};

export default ActionCheckBox;
